import { render, staticRenderFns } from "./FlatCodeTable.global.vue?vue&type=template&id=10273be9&scoped=true&lang=pug&"
import script from "./FlatCodeTable.global.vue?vue&type=script&lang=ts&"
export * from "./FlatCodeTable.global.vue?vue&type=script&lang=ts&"
import style0 from "./FlatCodeTable.global.vue?vue&type=style&index=0&id=10273be9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10273be9",
  null
  
)

export default component.exports